export default __webpack_public_path__ + "static/media/step-5-en.5dce29f4.png";